import {grayColors} from "../../architecture/gray-colors";

export const baseColors = {
    base01: "#7ff800", //brandGreen
    base01Contrast: "#000000",
    base01Dark: "#7aec37", //inchWorm
    base01Light: "#d2f800", //limeGreen

    base02: "#fce403", //turbo
    base02Contrast: "#000000",
    base02Dark: "#ffff00", //yellow
    base02Light: "#d5ec37", //pear

    base03: "#ff014f", //red
    base03Contrast: "#ffffff",
    base03Dark: "#e00146",
    base03Light: "#ff1a61",

    ...grayColors
}
